export const loading = ({ commit }, data) => {
  commit("LOADING", data)
}